module.exports = "<p>form-verification-condition-suspensive-test works!</p>\r\n"